export const visitConstants = {
  VISIT_LOAD: '[Visit] Load ',
  VISIT_LOAD_SUCCESS: '[Visit] Load success',
  VISIT_LOAD_FAILURE: '[Visit] Load failure',
  VISIT_RESET: '[Visit] Reset',
  VISIT_LOAD_DETAIL: '[Visit] Load detail',
  VISIT_LOAD_DETAIL_SUCCESS: '[Visit] Load detail success',
  VISIT_LOAD_DETAIL_FAILURE: '[Visit] Load detail failure'
}
